<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{'YEARAGREEMENT'|translate}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
  </button>
</div>

<div class="modal-body p-3">
  <div class="row mx-0">
    @if (type !== 'parts') {
      <div class="col-12 col-md-5">
        <div class="mb-3">
          <label>{{'YEARAGREEMENT'|translate}}</label>
          <ul class="list-group">
            @for (agreement of agreements; track agreement) {
              <li class="list-group-item">{{agreement.year}}
                @if (agreement?.locked && (agreement.signed || signed)) {
                  <i>{{'SIGNED'|translate}}: {{agreement.signed ? _getSignedDate(agreement.signed) : signDate}}</i>
                }
                @if (agreements.length > 1) {
                  <button class="btn btn-sm btn-success" (click)="getPdf(agreement, agreement.id)">{{'VIEW'|translate}}</button>
                }
              </li>
            }
          </ul>
        </div>
      </div>
    }

    <div class="col-12" [ngClass]="{'col-md-7': type !== 'parts'}">
      @if (pdfSrc) {
        <pdf-viewer class="pdf customScrollbar block float-left w-100" [src]="pdfSrc"></pdf-viewer>
      }
      @if (pdfSrc) {
        <div>
          <button class="btn btn-dark float-left mt-2" (click)="download()">{{'DOWNLOAD'|translate}}</button>
          @if (!selectedAgreement?.locked && show) {
            <div class="mt-2 block ">
              @if (type !== 'parts') {
                <div class="mb-3 mt-2">
                  <label for="dealerName">{{'DEALER_NAME'|translate}}</label>
                  <input type="text" class="form-control" id="dealerName" required [(ngModel)]="dealerName">
                </div>
              }
              @if (emailRequired) {
                <div class="mb-3 mt-2">
                  <label for="dealerName">{{'CONTRACT_EMAIL'|translate}}</label>
                  <input type="email" class="form-control" id="contractEmail" required  [(ngModel)]="contractEmail" [ngClass]="{'border-danger':emailInvalid}">
                </div>
              }
              @if (emailRequired) {
                <div class="mb-3 mt-2">
                  <label for="dealerName">{{'CONTRACT_EMAIL_CHECK'|translate}}</label>
                  <input type="email" class="form-control" id="contractEmailCheck" required  [(ngModel)]="contractEmailCheck" [ngClass]="{'border-danger':emailInvalid}">
                </div>
              }
              <div class="form-check mb-2">
                @if (type !== 'parts') {
                  <input type="checkbox" class="form-check-input" id="signCheck" [(ngModel)]="signed">
                  <label class="form-check-label" for="signCheck">{{'DEALER_AGREES'|translate}}</label>
                }
              </div>
              @if (type !== 'parts') {
                <button class="btn btn-success " [disabled]="!signed || !dealerName || sending || emailInvalid"
                (click)="sign()">{{'SIGN'|translate}}</button>
              }
            </div>
          }
          @if (type === 'parts' && show) {
            <div class="mt-2 block ">
              @if (type === 'parts') {
                <button class="btn btn-success "
                (click)="sign()">{{'CLOSE'|translate}}</button>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
